import { render } from "./CompletedModal.vue?vue&type=template&id=0ff712f2"
import script from "./CompletedModal.vue?vue&type=script&lang=js"
export * from "./CompletedModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__